/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
// import MDInput from "components/MDInput";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

function FormTimePicker({ input, ...rest }) {
  const { label } = rest;

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <TimePicker
        {...rest}
        label={label}
        value={input.value}
        onChange={(newValue) => {
          input.onChange(newValue);
        }}
        // Use your MDInput as the visual field
        // slots={{
        //   textField: MDInput,
        // }}
        // // Pass the styling and form-state props down
        // slotProps={{
        //   textField: {
        //     variant: "standard",
        //     fullWidth: true,
        //     // If 'rest' or 'input' contains error/meta from Redux Form or Formik:
        //     error: !!(rest.error || (rest.meta?.touched && rest.meta?.error)),
        //     helperText: rest.helperText || (rest.meta?.touched && rest.meta?.error),
        //   },
        // }}
      />
    </LocalizationProvider>
  );
}

// Setting default values for the props of FormDatePîcker
FormTimePicker.defaultProps = {
  label: " ",
  input: {},
  meta: {
    touched: false,
    invalid: false,
    error: "",
  },
};

// Typechecking props for FormTimePicker
FormTimePicker.propTypes = {
  label: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
    error: PropTypes.string,
  }),
};

export default FormTimePicker;
